// "use client";
// import Welcome from "@/app/componenets/Welcome";
// import Explore from "@/app/componenets/Explore";
// import LuxuryCommute from "@/app/componenets/LuxuryCommute";
// import Faq from "@/app/componenets/Faq";
// import Customer from "@/app/componenets/customersuport";
// import WhyChoose from "@/app/componenets/WhyChoose";
// import PremiumRides from "@/app/componenets/PremiumRides";
// import Slider from "@/app/componenets/Slider";
// import TopCity from "@/app/componenets/topCity";
// import TopRoutes from "@/app/componenets/topRoutes";
// import Homepage from "./componenets/Homep";
// import AlLoCation from "@/app/componenets/alllocations";
// import TawkTo from "./componenets/Tawko";
// import MyData from "@/app/data/Servies/hour_hire.json";
// import Head from "next/head";
// import Navbar from "@/app/componenets/Navbar";
// import Footer from "@/app/componenets/Footer";
//  import Heading from "@/app/componenets/Heading";
// export default function Home() {
//   const schemaMarkup = [
//     {
//       "@context": "https://schema.org/",
//       "@type": "WebSite",
//       name: "Prestige Ride",
//       url: "https://www.prestigeride.com",
//       potentialAction: {
//         "@type": "SearchAction",
//         target: "{search_term_string}",
//         "query-input": "required name=search_term_string",
//       },
//     },
//     {
//       "@context": "https://schema.org",
//       "@type": "Organization",
//       name: "Prestige Ride",
//       url: "https://www.prestigeride.com",
//       logo: "https://www.prestigeride.com/_next/static/media/Logo_Header.d54dbd16.svg",
//       contactPoint: {
//         "@type": "ContactPoint",
//         telephone: "(888) 346-9886",
//         contactType: "customer service",
//         contactOption: "TollFree",
//         areaServed: "US",
//         availableLanguage: "en",
//       },
//     },
//   ];

//   const schemaJsonString = JSON.stringify(schemaMarkup);

//   return (
//     <>
//       <Head>
//         <link
//           rel="stylesheet"
//           href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;700&display=swap"
//         />
//       </Head>

//       <title>Prestige Ride | First-Class Black Car & Chauffeur Services</title>
//       <meta
//         name="description"
//         content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
//       />
//       <meta property="og:site_name" content="Prestige Ride" />

//       {/* <!-- Facebook Meta Tags --> */}
//       <meta property="og:url" content="https://www.prestigeride.com" />
//       <meta property="og:type" content="website" />
//       <meta
//         property="og:title"
//         content="Prestige Ride | First-Class Black Car & Chauffeur Services"
//       />
//       <meta
//         property="og:description"
//         content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
//       />
//       <meta
//         property="og:image"
//         content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
//       />

//       <meta name="twitter:card" content="summary_large_image" />
//       <meta property="twitter:domain" content="prestigeride.com" />
//       <meta property="twitter:url" content="https://www.prestigeride.com" />
//       <meta
//         name="twitter:title"
//         content="Prestige Ride | First-Class Black Car & Chauffeur Services"
//       />
//       <meta
//         name="twitter:description"
//         content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
//       />
//       <meta
//         name="twitter:image"
//         content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
//       />
//       {/* --------------------------------------------------------------------------------------- */}
// <meta name="google-site-verification" content="e5HnF5erHafHYGqh1cbwxL0fsg1tedQMlWihgcPz1Mg" />
//       <meta name="robots" content="index, follow" />

//       <meta
//         name="keywords"
//         content="Luxury car service,
//         Elegant transportation,
//         Professional chauffeurs,
//         Premium ride experience,
//         Cutting-edge luxury travel,
//         Executive sedan service,
//         Sprinter van transportation,
//         Luxury SUV rides,
//         Premium SUV transport,
//         24/7 customer support,
//         Airport car service,
//         City to city rides,
//         Chauffeur service excellence,
//         Luxury travel to NYC,
//         Boston city car service,
//         Luxury rides to Orlando,
//         Connecticut travel with style,
//         Atlantic City car experience,
//         Philadelphia prestige ride,
//         East Hampton chauffeured travel,
//         Premium ride service,
//         Black car service,
//         Luxury airport transfers,
//         Professional chauffeur services,
//         Seamless point-to-point service,
//         Exclusive city tours,
//         City-to-city rides in style,
//         Tailored meetings and offsite events,
//         VIP client and partner travels,
//         Flexible hourly hire options,
//         Premium services for special events,
//         Prestige ride home page,
//         Personalized transportation solutions,
//         Executive travel with prestige,
//         Elegant chauffeur-driven rides,
//         Reliable point-to-point transfers,
//         Unforgettable city tour experiences,
//         Seamless city-to-city journeys,
//         Corporate meetings and events transport,
//         Client and partner travel excellence,
//         Convenient hourly hire services.
//         "
//       />
//       <meta
//         name="ahrefs-site-verification"
//         content="9cbd6ff3b1f73bd27f6a48bf01e03a44ec19ebc9d005155e56923f3049050ca3"
//       ></meta>

//       <link rel="canonical" href="https://www.prestigeride.com" />
//       <script
//         type="application/ld+json"
//         dangerouslySetInnerHTML={{ __html: schemaJsonString }}
//       ></script>
//       <TawkTo />
// <Heading/>
//       <Navbar />
//       <Homepage image={"homepage"} />
//       {/* <Hero/>  */}
//       <Welcome />
//       <Explore />
//       <Customer />
//       <WhyChoose />
//       <LuxuryCommute />
//       <TopRoutes />
//       <AlLoCation />
//       <TopCity />
//       <PremiumRides />
//       {/* <Review/> */}
//       <Faq />
//       <Footer />
//     </>
//   );
// }

"use client";
import dynamic from "next/dynamic";
import Head from "next/head";
import Navbar from "@/app/componenets/Navbar";
import Footer from "@/app/componenets/Footer";
import Homepage from "./componenets/Homep";
import Heading from "@/app/componenets/Heading";

const Welcome = dynamic(() => import("@/app/componenets/Welcome"));
const Explore = dynamic(() => import("@/app/componenets/Explore"));
const LuxuryCommute = dynamic(() => import("@/app/componenets/LuxuryCommute"));
const Faq = dynamic(() => import("@/app/componenets/Faq"));
const Customer = dynamic(() => import("@/app/componenets/customersuport"));
const WhyChoose = dynamic(() => import("@/app/componenets/WhyChoose"));
const PremiumRides = dynamic(() => import("@/app/componenets/PremiumRides"));
const Slider = dynamic(() => import("@/app/componenets/Slider"));
const TopCity = dynamic(() => import("@/app/componenets/topCity"));
const TopRoutes = dynamic(() => import("@/app/componenets/topRoutes"));
const AlLoCation = dynamic(() => import("@/app/componenets/alllocations"));

export default function Home() {
  const schemaMarkup = [
    {
      "@context": "https://schema.org/",
      "@type": "WebSite",
      name: "Prestige Ride",
      url: "https://www.prestigeride.com",
      potentialAction: {
        "@type": "SearchAction",
        target: "{search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Prestige Ride",
      url: "https://www.prestigeride.com",
      logo: "https://www.prestigeride.com/_next/static/media/Logo_Header.d54dbd16.svg",
      contactPoint: {
        "@type": "ContactPoint",
        telephone: "(888) 346-9886",
        contactType: "customer service",
        contactOption: "TollFree",
        areaServed: "US",
        availableLanguage: "en",
      },
    },
  ]; // Same as before
  const schemaJsonString = JSON.stringify(schemaMarkup);

  return (
    <>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: schemaJsonString }}
        />
      </Head>
      <title>Prestige Ride | First-Class Black Car & Chauffeur Services</title>
      <meta
        name="description"
        content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
      />
      <meta
        name="google-site-verification"
        content="e5HnF5erHafHYGqh1cbwxL0fsg1tedQMlWihgcPz1Mg"
      />
      <meta
        name="ahrefs-site-verification"
        content="9cbd6ff3b1f73bd27f6a48bf01e03a44ec19ebc9d005155e56923f3049050ca3"
      ></meta>
      <link rel="canonical" href="https://www.prestigeride.com" />
      <meta name="robots" content="index, follow" />
      <meta property="og:site_name" content="Prestige Ride" />
      {/* <!-- Facebook Meta Tags --> */}
      <meta property="og:url" content="https://www.prestigeride.com" />
      <meta property="og:type" content="website" />
      <meta
        property="og:title"
        content="Prestige Ride | First-Class Black Car & Chauffeur Services"
      />
      <meta
        property="og:description"
        content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
      />
      <meta
        property="og:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta property="twitter:domain" content="prestigeride.com" />
      <meta property="twitter:url" content="https://www.prestigeride.com" />
      <meta
        name="twitter:title"
        content="Prestige Ride | First-Class Black Car & Chauffeur Services"
      />
      <meta
        name="twitter:description"
        content="Prestige Ride offers luxury car transportation services along with well-trained chauffeurs and vehicles to make your next trip unforgettable."
      />
      <meta
        name="twitter:image"
        content="https://www.prestigeride.com/updated-home/twitterCArd.jpg"
      />
      <meta name="google-site-verification" content="e5HnF5erHafHYGqh1cbwxL0fsg1tedQMlWihgcPz1Mg" />
      
       <meta
         name="ahrefs-site-verification"
         content="9cbd6ff3b1f73bd27f6a48bf01e03a44ec19ebc9d005155e56923f3049050ca3"
       ></meta>
           

      <Heading />
      <Navbar />
      <Homepage image={"homepage"} />
      <Welcome />
      <Explore />
      <Customer />
      <WhyChoose />
      <LuxuryCommute />
      <TopRoutes />
      <AlLoCation />
      <TopCity />
      <PremiumRides />
      <Faq />
      <Footer />
    </>
  );
}
